var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwiter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_Twiter",
    width: 24,
    height: 24,
    "data-name": "Icon - Twiter",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2465",
    fill: "none",
    d: "M0 0H24V24H0z",
    "data-name": "Rectangle 2465"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_5902",
    "data-name": "Group 5902",
    transform: "translate(-51.523 -87.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_5901",
    "data-name": "Group 5901",
    transform: "translate(55.274 92.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8016",
    fill: "#1da1f2",
    d: "M61.079 107.868a10.7 10.7 0 0 0 10.773-10.774c0-.164 0-.327-.011-.49a7.708 7.708 0 0 0 1.889-1.961 7.561 7.561 0 0 1-2.175.6 3.8 3.8 0 0 0 1.665-2.095 7.59 7.59 0 0 1-2.4.919 3.79 3.79 0 0 0-6.453 3.453 10.75 10.75 0 0 1-7.805-3.956 3.79 3.79 0 0 0 1.172 5.055 3.758 3.758 0 0 1-1.715-.474v.048a3.788 3.788 0 0 0 3.038 3.712 3.78 3.78 0 0 1-1.71.065 3.791 3.791 0 0 0 3.538 2.63 7.6 7.6 0 0 1-4.7 1.621 7.72 7.72 0 0 1-.9-.052 10.72 10.72 0 0 0 5.8 1.7",
    "data-name": "Path 8016",
    transform: "translate(-55.274 -92.868)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwiter);
export default __webpack_public_path__ + "static/media/icon-twiter.95e25d5812a63ec76d61e989f2646099.svg";
export { ForwardRef as ReactComponent };